// noinspection DuplicatedCode

import 'glider-js/glider.css';
import './scss/index.scss';

import Glider from 'glider-js';
import MicroModal from 'micromodal';
import Api from './api';


shopAddsPlugin.api = new Api(shopAddsPlugin);
shopAddsPlugin.Glider = Glider;

$(document).on('change', '[adds-switch]', function() {
  const product_id = this.getAttribute('adds-item-product-id');
  const sku_id = this.getAttribute('adds-item-sku-id');
  shopAddsPlugin.api.addProduct(product_id, sku_id);
});

$(document).on('click', '[adds-info]', function() {
  const product_id = this.getAttribute('adds-item-product-id');
  const sku_id = this.getAttribute('adds-item-sku-id');
  const list_id = this.getAttribute('adds-item-list-id');

  MicroModal.show('adds-modal', {
    onShow(modal) {
      const list = shopAddsPlugin.lists[list_id];
      const product = Object.values(list).find((product) => {
        return product.id === product_id && product.sku_id === sku_id;
      });

      const container = modal.querySelector('[adds-container]');
      let template = `<div class="adds__product--block adds__product--title">${product.name}</div>`;
      if (product.img_url.trim()) {
        template += `<div class="adds__product--block"><img class="adds__product--image" src="${product.img_url}"></div>`;
      }
      if (product.description.trim()) {
        template += `<div class="adds__product--block adds__product--description">${product.description}</div>`;
      }
      template += `<div class="adds__product--block adds__price adds__product--price">${product.price_formatted}</div>`;
      template += `
          <div class="adds__product--block adds__product--purchase">
             <span class="adds__product--close adds__product--purchase--item" adds-modal-close>Іншого разу</span>
             <div adds-add-to-cart class="adds__product--button adds__product--purchase--item">Додати до кошика</div>
          </div>
        `;
      container.innerHTML = template;
      container.querySelector('[adds-add-to-cart]').addEventListener('click', () => {
        shopAddsPlugin.api.addProduct(product_id, sku_id).then(() => {
          MicroModal.close('adds-modal');
        });
      });
    },
    closeTrigger: 'adds-modal-close',
    openClass: 'is-open',
    disableScroll: true,
    disableFocus: false,
    awaitOpenAnimation: true,
    awaitCloseAnimation: true,
  });
});

// Обработчик для кнопки информации (иконка "i")
$(document).on('click', '[adds-info-button]', function() {
  const info_text = shopAddsPlugin.settings.block_info || 'Ви можете додати романтичні послуги до вашого замовлення.';
  
  MicroModal.show('adds-modal', {
    onShow(modal) {
      const container = modal.querySelector('[adds-container]');
      let template = `<div class="adds__product--block adds__product--title">Інформація</div>`;
      template += `<div class="adds__product--block adds__product--description">${info_text}</div>`;
      template += `
          <div class="adds__product--block adds__product--purchase">
             <span class="adds__product--close adds__product--purchase--item" adds-modal-close>Зрозуміло</span>
          </div>
        `;
      container.innerHTML = template;
    },
    closeTrigger: 'adds-modal-close',
    openClass: 'is-open',
    disableScroll: true,
    disableFocus: false,
    awaitOpenAnimation: true,
    awaitCloseAnimation: true,
  });
});

// Обработчик для кнопок +1 в компактном режиме
$(document).on('click', '[adds-add-button]', function() {
  const button = this;
  const product_id = button.getAttribute('adds-item-product-id');
  const sku_id = button.getAttribute('adds-item-sku-id');
  
  // Добавляем в корзину
  shopAddsPlugin.api.addProduct(product_id, sku_id).then(() => {
    // Визуальная обратная связь
    button.classList.add('adds__compact--add-button--active');
    setTimeout(() => {
      button.classList.remove('adds__compact--add-button--active');
    }, 300);
  });
});